import React from "react";
import { api_auth, api_host } from "../../../../common/globals/constants";
import queryString from "query-string";

export function useConfiguracionLimites() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [isError, setIsError] = React.useState(false);
  const [error, setError] = React.useState("");
  const [isSuccess, setIsSuccess] = React.useState();

  React.useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    setIsLoading(true);
    setIsError(false);
    try {
      const queryParamsParsed = queryString.parse(document.location.search);
      const dateMilisegundos = Date.now();
      const token = sessionStorage.getItem("key");
      const user = sessionStorage.getItem("user");

      const isPublic = document.location.pathname === "/public/flashboard";
      const urlToken = queryParamsParsed["token"]
      const publicUrl = `${api_host}/public/flashboard/configuracionLimites/?token=${urlToken}`;
      const withAuthUrl = `${api_host}/reporte/online/indicadores/getConfiguracionLimites/?token=${token}&user=${user}&key=${api_auth}&date=${dateMilisegundos}`;

      const response = await fetch(isPublic ? publicUrl : withAuthUrl);

      if (!response.ok) {
        throw new Error("Error al cargar los datos desde el servidor");
      }
      const data = await response.json();
      setData(data);
      setIsSuccess(true);
    } catch (err) {
      console.error(err);
      setIsError(true);
      setError(err.message || "Ha ocurrido un error");
    } finally {
      setIsLoading(false);
    }
  }

  function refetch() {
    fetchData();
  }

  return { isLoading, data, isError, refetch, error, isSuccess };
}
